import React from "react";
import { Button } from "antd";
import SupplierOrder from "../../components/tables/SupplierOrders";

const SupplierOrderPage = () => {
	return (
		<>
			<SupplierOrder button={Button} />
		</>
	);
};

export default SupplierOrderPage;
